import React from 'react';
import UserInfoSelect from './Select';
import { AccountManagementRes, AccountManagementSubRow } from '../../columns';

interface IUserInfo {
  account: AccountManagementRes;
  selected: AccountManagementSubRow | undefined;
  handleSelectUser: (payload?: AccountManagementSubRow) => void;
  handleDeleteUser: () => void;
}

function UserInfo({ account, selected, handleSelectUser, handleDeleteUser }: IUserInfo) {
  return (
    <div className="rounded-lg border overflow-hidden">
      <div className="flex items-center gap-[20px] bg-[#5582B42E] p-[10px] min-h-[64px] justify-between">
        <div className="pl-[10px] font-bold text-primary text-[20px]">User Information</div>
        {selected ? (
          <UserInfoSelect
            selected={selected}
            handleSelect={handleSelectUser}
            users={account.subRows}
            handleDeleteUser={handleDeleteUser}
          />
        ) : null}
      </div>
      <div className="p-[20px] grid gap-[10px]">
        {selected ? (
          <div className="grid gap-[10px]">
            <div className="grid grid-cols-[200px,auto] gap-[10px]">
              <div className="opacity-80 text-primary">Status:</div>
              <div className="font-bold uppercase">{selected.status}</div>
            </div>
            <div className="grid grid-cols-[200px,auto] gap-[10px]">
              <div className="opacity-80 text-primary">User Name:</div>
              <div className="font-medium">{selected.name}</div>
            </div>
            <div className="grid grid-cols-[200px,auto] gap-[10px]">
              <div className="opacity-80 text-primary">Unique Identifier:</div>
              <div className="font-medium">{selected.cif}</div>
            </div>
            <div className="grid grid-cols-[200px,auto] gap-[10px]">
              <div className="opacity-80 text-primary">SSO Enroll Date:</div>
              <div className="font-medium">{selected.ssoEnrollDate}</div>
            </div>
            <div className="grid grid-cols-[200px,auto] gap-[10px]">
              <div className="opacity-80 text-primary">DSO Enroll Date:</div>
              <div className="font-medium">{selected.dsoEnrollDate}</div>
            </div>
            <div className="grid grid-cols-[200px,auto] gap-[10px]">
              <div className="opacity-80 text-primary">Session Last Login:</div>
              <div className="font-medium">{selected.lastLogin}</div>
            </div>
            <div className="grid grid-cols-[200px,auto] gap-[10px]">
              <div className="opacity-80 text-primary">Session Failed Counter:</div>
              <div className="font-medium">{selected.failedLoginCounter}</div>
            </div>
            <div className="grid grid-cols-[200px,auto] gap-[10px]">
              <div className="opacity-80 text-primary">Enrollment Status:</div>
              <div className="font-medium">{selected.enrollmentStatus}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default UserInfo;
